module.exports = __webpack_public_path__ + "img/KSC04642.5133596d.jpg";